import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

/**
 * Tab individual dentro de `<app-chair-tabs>`. Define rótulo (e opcionalmente
 * disabled) e captura o conteúdo via `<ng-template>` — o `<app-chair-tabs>`
 * pai decide qual conteúdo renderizar com base no `selectedIndex`.
 *
 * Uso:
 * ```html
 * <app-chair-tabs [(selectedIndex)]="i">
 *   <app-chair-tab label="Convidados">
 *     <app-people-table ...></app-people-table>
 *   </app-chair-tab>
 *   <app-chair-tab label="Declinados" [disabled]="!hasDeclined">
 *     ...
 *   </app-chair-tab>
 * </app-chair-tabs>
 * ```
 *
 * O `label` aceita string pura ou expressão (`label="{{ 'i18n.key' | translate }}"`).
 * Pra escapar do interpolation do label e usar pipe direto, use property binding:
 * `[label]="'i18n.key' | translate"`.
 */
@Component({
  selector: 'app-chair-tab',
  template: '<ng-template #content><ng-content></ng-content></ng-template>',
})
export class ChairTabComponent {
  @Input() label = '';
  @Input() disabled = false;

  @ViewChild('content', { static: true }) content!: TemplateRef<any>;
}
